import repository from '@/api/repository';
import { BANK_ACCOUNTS } from '@/constants/repository';
import { BankAccount } from '@/api/payment-orders';

export interface DirectDebitMandateDto {
  mandateId: string;
  dateOfSignature: string;
}

export interface BankAccountDto {
  id: string;
  iban: string| null;
  name: string;
  synesisCode: string | null;
  isPayable: boolean;
  directDebitMandate?: DirectDebitMandateDto | null;
  creditorSchemeId?: string | null;
}

export interface CreateBankAccountDto {
  iban?: string | null;
  name: string;
  synesisCode?: string | null;
  isPayable: boolean;
  directDebitMandate?: DirectDebitMandateDto | null;
  creditorSchemeId?: string | null;
}

export interface UpdateBankAccountDto {
  iban: string | null;
  name: string;
  synesisCode: string | null;
  isPayable: boolean;
  directDebitMandate?: DirectDebitMandateDto | null;
  creditorSchemeId?: string | null;
}

export default {
  get() {
    return repository.get<BankAccountDto[]>(BANK_ACCOUNTS);
  },

  post(bankAccount: BankAccount) {
    return repository.post<BankAccountDto>(BANK_ACCOUNTS, bankAccount);
  },

  put(id: string, bankAccount: BankAccount) {
    return repository.put<UpdateBankAccountDto>(`${BANK_ACCOUNTS}/${id}`, bankAccount);
  },

  delete(id: string) {
    return repository.delete<void>(`${BANK_ACCOUNTS}/${id}`);
  },
};
